import type {
  FieldType,
  FormField
} from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';

export const useInvalidFieldErrorMessageGetter = () => {
  const { t } = useLingui();
  const fieldTranslationsMap: Partial<Record<FieldType, string>> = {
    phone: t`Please enter a valid phone number`,
    email: t`Please enter a valid email`,
    number: t`Please enter a valid number`,
    URL: t`Please enter a valid URL`
  };

  return ({ type, name }: FormField) => {
    return fieldTranslationsMap[type] ?? t`Please enter a valid ${name}`;
  };
};
